import { render, staticRenderFns } from "./AdmissionDashboard.vue?vue&type=template&id=19697bf4&scoped=true"
import script from "./AdmissionDashboard.vue?vue&type=script&lang=js"
export * from "./AdmissionDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdmissionDashboard.vue?vue&type=style&index=0&id=19697bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19697bf4",
  null
  
)

export default component.exports